import loader from "./loader";
import PlaceSearch from "./PlaceSearch";

const GMaps = {
  install: (app, options) => {
    const finalOptions = Object.assign({}, options);

    app.config.globalProperties.$GMaps = GMaps.finalOptions;

    if (finalOptions.load) {
      loader.load(finalOptions.load);
    }

    app.component("PlaceSearch", PlaceSearch);
  },
};

export default GMaps;
